import type { FeatureFlags } from '@front/type/feature-flags'

export interface MockedFeatureTogglesContext {
  flags: FeatureFlags
  status: 'idle' | 'error' | 'loading' | 'success'
}

export const mockedFeatureFlags: MockedFeatureTogglesContext = {
  flags: {
    devTeam: {
      isCool: false,
    },
    indexPageBehavior: 'is-dev-team-cool',
    useNewAdminLogin: true,
    useLabApps: false,
    useNewJobsSpecialtiesRoute: false,
    useNewWorkerInstitutions: true,
    useNewAgencyShiftRequest: false,
    usePlatformSlowdownBanner: false,
    useHublerAppSlowdownBanner: false,
    enableHublerDeletion: true,
    trackActiveHubler: true,
    useBroadcastPoolOffersWhenHubloPoolInstitutionOptionActivated: false,
    useTimeZoneManagement: false,
    useDatadogRum: false,
    useSupportSessionReplay: false,
    useCustomerIO: false,
    useWhatsappWidget: false,
    useInstitutionConfiguration: false,
    useHublerGenericJobs: false,
  },
  status: 'success',
}
